"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverAnimation = exports.ThemeContext = exports.ThemeProvider = exports.useTheme = exports.Flag = exports.SelectBar = exports.SecurityCard = exports.Card = exports.Box = exports.DeviceImage = exports.ConfirmOnDevice = exports.types = exports.Truncate = exports.Timerange = exports.TooltipConditional = exports.Tooltip = exports.Loader = exports.TrezorLogo = exports.CoinLogo = exports.Modal = exports.Warning = exports.Link = exports.P = exports.H2 = exports.H1 = exports.Icon = exports.Switch = exports.RadioButton = exports.Checkbox = exports.Select = exports.Textarea = exports.Input = exports.Dropdown = exports.ButtonPin = exports.Button = exports.variables = exports.THEME = exports.colors = void 0;
var colors_1 = __importStar(require("./config/colors"));
exports.colors = colors_1.default;
Object.defineProperty(exports, "THEME", { enumerable: true, get: function () { return colors_1.THEME; } });
var variables = __importStar(require("./config/variables"));
exports.variables = variables;
var utils_1 = require("./utils");
Object.defineProperty(exports, "useTheme", { enumerable: true, get: function () { return utils_1.useTheme; } });
var Button_1 = require("./components/buttons/Button");
Object.defineProperty(exports, "Button", { enumerable: true, get: function () { return Button_1.Button; } });
var Flag_1 = require("./components/Flag");
Object.defineProperty(exports, "Flag", { enumerable: true, get: function () { return Flag_1.Flag; } });
var Pin_1 = require("./components/buttons/Pin");
Object.defineProperty(exports, "ButtonPin", { enumerable: true, get: function () { return Pin_1.ButtonPin; } });
var DeviceImage_1 = require("./components/DeviceImage");
Object.defineProperty(exports, "DeviceImage", { enumerable: true, get: function () { return DeviceImage_1.DeviceImage; } });
var Dropdown_1 = require("./components/Dropdown");
Object.defineProperty(exports, "Dropdown", { enumerable: true, get: function () { return Dropdown_1.Dropdown; } });
var Input_1 = require("./components/form/Input");
Object.defineProperty(exports, "Input", { enumerable: true, get: function () { return Input_1.Input; } });
var Textarea_1 = require("./components/form/Textarea");
Object.defineProperty(exports, "Textarea", { enumerable: true, get: function () { return Textarea_1.Textarea; } });
var Select_1 = require("./components/form/Select");
Object.defineProperty(exports, "Select", { enumerable: true, get: function () { return Select_1.Select; } });
var Checkbox_1 = require("./components/form/Checkbox");
Object.defineProperty(exports, "Checkbox", { enumerable: true, get: function () { return Checkbox_1.Checkbox; } });
var RadioButton_1 = require("./components/form/RadioButton");
Object.defineProperty(exports, "RadioButton", { enumerable: true, get: function () { return RadioButton_1.RadioButton; } });
var Switch_1 = require("./components/form/Switch");
Object.defineProperty(exports, "Switch", { enumerable: true, get: function () { return Switch_1.Switch; } });
var Icon_1 = require("./components/Icon");
Object.defineProperty(exports, "Icon", { enumerable: true, get: function () { return Icon_1.Icon; } });
var Heading_1 = require("./components/typography/Heading");
Object.defineProperty(exports, "H1", { enumerable: true, get: function () { return Heading_1.H1; } });
Object.defineProperty(exports, "H2", { enumerable: true, get: function () { return Heading_1.H2; } });
var Paragraph_1 = require("./components/typography/Paragraph");
Object.defineProperty(exports, "P", { enumerable: true, get: function () { return Paragraph_1.P; } });
var Link_1 = require("./components/typography/Link");
Object.defineProperty(exports, "Link", { enumerable: true, get: function () { return Link_1.Link; } });
var Warning_1 = require("./components/Warning");
Object.defineProperty(exports, "Warning", { enumerable: true, get: function () { return Warning_1.Warning; } });
var Box_1 = require("./components/others/Box");
Object.defineProperty(exports, "Box", { enumerable: true, get: function () { return Box_1.Box; } });
var Card_1 = require("./components/others/Card");
Object.defineProperty(exports, "Card", { enumerable: true, get: function () { return Card_1.Card; } });
var SecurityCard_1 = require("./components/others/SecurityCard");
Object.defineProperty(exports, "SecurityCard", { enumerable: true, get: function () { return SecurityCard_1.SecurityCard; } });
var ConfirmOnDevice_1 = require("./components/prompts/ConfirmOnDevice");
Object.defineProperty(exports, "ConfirmOnDevice", { enumerable: true, get: function () { return ConfirmOnDevice_1.ConfirmOnDevice; } });
var Modal_1 = require("./components/Modal");
Object.defineProperty(exports, "Modal", { enumerable: true, get: function () { return Modal_1.Modal; } });
var CoinLogo_1 = require("./components/logos/CoinLogo");
Object.defineProperty(exports, "CoinLogo", { enumerable: true, get: function () { return CoinLogo_1.CoinLogo; } });
var TrezorLogo_1 = require("./components/logos/TrezorLogo");
Object.defineProperty(exports, "TrezorLogo", { enumerable: true, get: function () { return TrezorLogo_1.TrezorLogo; } });
var Loader_1 = require("./components/loaders/Loader");
Object.defineProperty(exports, "Loader", { enumerable: true, get: function () { return Loader_1.Loader; } });
var Tooltip_1 = require("./components/Tooltip");
Object.defineProperty(exports, "Tooltip", { enumerable: true, get: function () { return Tooltip_1.Tooltip; } });
var TooltipConditional_1 = require("./components/Tooltip/TooltipConditional");
Object.defineProperty(exports, "TooltipConditional", { enumerable: true, get: function () { return TooltipConditional_1.TooltipConditional; } });
var Timerange_1 = require("./components/Timerange");
Object.defineProperty(exports, "Timerange", { enumerable: true, get: function () { return Timerange_1.Timerange; } });
var Truncate_1 = require("./components/Truncate");
Object.defineProperty(exports, "Truncate", { enumerable: true, get: function () { return Truncate_1.Truncate; } });
var SelectBar_1 = require("./components/form/SelectBar");
Object.defineProperty(exports, "SelectBar", { enumerable: true, get: function () { return SelectBar_1.SelectBar; } });
var ThemeProvider_1 = require("./support/ThemeProvider");
Object.defineProperty(exports, "ThemeProvider", { enumerable: true, get: function () { return ThemeProvider_1.ThemeProvider; } });
Object.defineProperty(exports, "ThemeContext", { enumerable: true, get: function () { return ThemeProvider_1.ThemeContext; } });
var types = __importStar(require("./support/types"));
exports.types = types;
var HoverAnimation_1 = require("./components/HoverAnimation");
Object.defineProperty(exports, "HoverAnimation", { enumerable: true, get: function () { return HoverAnimation_1.HoverAnimation; } });
